import React from 'react';
import PropTypes from 'prop-types';
import ReferralSection from './ReferralSection';

const RegistrationComplete = ({ referralLink, copySuccess, onCopyLink, htmlId, className = '', ctaButtonText, ctaButtonLink }) => (
  <div id={htmlId} className={`max-w-[1440px] mx-auto px-8 py-12 ${className}`}>
    <div className="max-w-[1152px]">
      <h1 className="text-[48px] font-bold leading-[62px] text-[#1C2938] mb-4"
        style={{ fontFamily: 'Poppins, sans-serif' }}>
        Thank you!
      </h1>

      <p className="text-[18px] font-normal leading-[23px] text-black mb-8"
        style={{ fontFamily: 'Poppins, sans-serif' }}>
        You are now signed up to be a part of Ship&Play&apos;s travel advisor registry.
      </p>

      <a
        href={ctaButtonLink || '/ship'}
        className="inline-block px-8 py-3 text-white font-semibold text-[16px] leading-[20px]
          bg-[#1C2938] rounded-lg mb-10 no-underline"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        {ctaButtonText || 'Book now'}
      </a>

      {referralLink && (
        <ReferralSection
          referralLink={referralLink}
          copySuccess={copySuccess}
          onCopyLink={onCopyLink}
        />
      )}
    </div>
  </div>
);

RegistrationComplete.propTypes = {
  referralLink: PropTypes.string,
  copySuccess: PropTypes.bool.isRequired,
  onCopyLink: PropTypes.func.isRequired,
  htmlId: PropTypes.string,
  className: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaButtonLink: PropTypes.string
};

export default RegistrationComplete;
